import React, { useState } from 'react'
import classNames from 'classnames'
import useSWR, { mutate }  from 'swr'
//import API from '../../api'
import { getCurrentPage } from './pages'
import { selectOptions, getSortStatusName } from './options'
import { GlossaryFetcher } from '../../fetch/glossary'
// Components
import {
    Table,
    Button,
    Icon,
    Header,
    Input,
    Grid,
    Dropdown,
    Pagination
} from 'semantic-ui-react'
import Loader from '../loader'
import {Message} from '../error'
import {DataObjectDialog,
    DataElementDialog,
    DataDialog} from './dialogs'
import SidebarPanel from './SidebarPanel'

// Styles
import {pointer, activeRow, content, sampleValue, dataDomain, dataElement, dataType, dataObject, paginationDiv} from './sidebar.module.scss'


export default function Glossary({history, match}) {

    const [state, setState] = useState({
        status: '',
        dialogOpen: false,
        dialogLoading: false,
        sidebarVisible: false,
        itemID: null,
        sidebarItem: {},
        shouldFetchDetail: false,
        shouldFetchSearch: false,
        editDialog: false,
        //searchTerm: ''
    })
    const inputRef = React.useRef();

    const currentPage = getCurrentPage(match.params.page)
    const currentStatus = match.params.status ? `/${match.params.status}` : ''

    const [activePage, setActivePage] = useState(1);
    const [totalPages, setTotalPages] = useState([]);

    const handleDialogVisibility = () => {
        state.dialogOpen && setState(state => {
            return {
                ...state,
                editDialog: false
            }
        })
        setState( state => {
            return {
                ...state,
                dialogOpen: !state.dialogOpen,
                dialogLoading: false
            }
        })
    }

    const handleSort = ( e, { value }) => {
        if ( value === 'all' )
            history.push(`/glossary/${currentPage.id}`)
        else
            history.push(`/glossary/${currentPage.id}/${value}`)
    }

    const handleSave = data => {
        mutate(`/${currentPage.id}/list${currentStatus}/1`)
        /*state.sidebarVisible && */mutate(`/${currentPage.id}/details/${state.itemID}`)
        setState( state => {
            return {
                ...state,
                dialogOpen: false,
                dialogLoading: false,
                editDialog: false
            }
        })

    }


    const { data: itemDetails, errorDetails } = useSWR(!state.shouldFetchDetail ? null : `/${currentPage.id}/details/${state.itemID}`, GlossaryFetcher, { errorRetryCount: 2 });

    const toggleSidebar = item => {

        if (state.sidebarVisible && item.id === state.sidebarItem.id) {

            return setState( state => {
                return {
                    ...state,
                    sidebarVisible: false,
                    shouldFetchDetail: false,
                    itemID: null,
                    sidebarItem: {}
                }
            })

        }

        setState( state => {
            return {
                ...state,
                sidebarVisible: true,
                shouldFetchDetail: true,
                itemID: item.id,
                sidebarItem: item
            }
        })

    }

    const closeSidebar = () => {
        setState( state => {
            return {
                ...state,
                sidebarVisible: false,
                sidebarItem: {}
            }
        })
    }

    const editSidebar = () => {
        mutate(`/${currentPage.id}/details/${state.itemID}`)
        setState( state => {
            return {
                ...state,
                dialogOpen: true,
                editDialog: true,
            }
        })
    }

    //const { data : list, error } = useSWR(`/${currentPage.id}/list${currentStatus}`, GlossaryFetcher, { errorRetryCount: 2 })
    const [searchTerm, setSearchTerm] = useState("");
    history.listen( location =>  {
        setSearchTerm("");
        setActivePage(1);
        setState( state => {
            return {
                ...state,
                shouldFetchDetail: false,
            }
        })
    });

    const onPageChange = (e, pageInfo) => {
        !isNaN(pageInfo.activePage) && setActivePage(pageInfo.activePage)
    }
    
    let urlPart = "/list/" + activePage;
    if(searchTerm) {
        if(currentStatus) {
            urlPart = "/filter/by-status/" + searchTerm + currentStatus + "/" + activePage
        }
        else {
            urlPart = "/filter/" + searchTerm + "/" + activePage
        }
    }
    else {
        if(currentStatus) {
            urlPart = "/list" + currentStatus + "/" + activePage
        }
    }

    const [list, setList] = useState([]);
    const { data, error } = useSWR(`/${currentPage.id}${urlPart}`, GlossaryFetcher, { errorRetryCount: 2 })

    if(data) {
        if(data.data !== list ) setList(data.data);
        if( data.messages && totalPages !== data.messages.totalPages) setTotalPages(data.messages.totalPages)
    }

    if (error && error.response && error.response.data) {
        return (
            <div className={content}>
                <Message negative header={error.response.data.statusMessage} />
            </div>
        )
    }

    //if (!data && searchTerm === "") return <Loader /> /* TODO: remove searchTerm, loader samo umjesto tablice ne svega */

    const handleSearch = (e, {value}) => {
        setSearchTerm(value)
        setActivePage(1)
    }

    return (

        <>
            <div className={content}>

                <Header size="huge">{currentPage.name}</Header>

                <Button primary onClick={ handleDialogVisibility }>
                    <Icon style={{marginRight: '15px !important'}} name="plus" />
                    Create new
                </Button>

                <br /><br />

                <Grid>
                    <Grid.Row>
                        <Grid.Column width={8}>
                            <Input
                                icon="search"
                                iconPosition="left"
                                placeholder="Search..."
                                onChange={handleSearch}
                                value={searchTerm}
                                inputref={inputRef}
                            />
                        </Grid.Column>
                        <Grid.Column width={8} textAlign="right" key={currentStatus}>
                            <Dropdown
                                search
                                selection
                                placeholder="Status"
                                defaultValue={currentStatus.replace('/', '')}
                                options={selectOptions}
                                onChange={handleSort}
                                icon={"chevron down"}
                                style={{cursor: "pointer"}}
                            />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>

                {!data && <Loader />}

                <Table basic="very">

                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Name</Table.HeaderCell>
                            <Table.HeaderCell>Definition</Table.HeaderCell>
                            <Table.HeaderCell>Status</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>




                    {data && <Table.Body>

                        { list && list.map(item => {
                            return (
                                <Table.Row
                                    key={`item-${item.id}`}
                                    className={classNames(pointer,
                                        {[activeRow]: state.sidebarItem.id === item.id},
                                        {[sampleValue]: currentPage.id === "sample-value" },
                                        {[dataDomain]: currentPage.id === "data-domain" },
                                        {[dataElement]: currentPage.id === "data-element" },
                                        {[dataObject]: currentPage.id === "data-object" },
                                        {[dataType]: currentPage.id === "data-type" },
                                        )}
                                    onClick={() => toggleSidebar(item)}
                                >
                                    <Table.Cell>{item.name}</Table.Cell>
                                    <Table.Cell>{item.definition}</Table.Cell>
                                    <Table.Cell>{getSortStatusName(item.status)}</Table.Cell>
                                </Table.Row>
                            )
                        })}



                        {(list && list.length < 1) && (
                            <Table.Row>
                                <Table.Cell width={3}>No data</Table.Cell>
                            </Table.Row>
                        )}

                    </Table.Body>}
                </Table>

                {data && totalPages > 1 && <div className={paginationDiv}>
                    <Pagination
                        activePage = {activePage}
                        onPageChange={onPageChange}
                        firstItem = {null} //{"⟨⟨"}
                        lastItem = {null} // {"⟩⟩"}
                        nextItem = {activePage === Number(totalPages) ? null : "Next"}
                        prevItem = {activePage === 1 ? null : "Previous"}
                        totalPages ={totalPages}
                        pointing
                        secondary
                    />
                </div>}

            </div>

            { itemDetails && <SidebarPanel
                visible={state.sidebarVisible}
                item={itemDetails}
                typeName={`${currentPage.singularName}`}
                close={closeSidebar}
                edit={editSidebar}
            />}

            {(currentPage.id === "data-object") && <DataObjectDialog
                title={state.editDialog ? `Edit ${currentPage.singularName}` : `Create new ${currentPage.singularName}`}
                open={state.dialogOpen}
                loading={state.dialogLoading}
                onSubmit={handleSave}
                onClose={handleDialogVisibility}
                item={(state.editDialog && itemDetails) ? itemDetails.data : {}}
            />}

            {(currentPage.id === "data-element") && <DataElementDialog
                title={state.editDialog ? `Edit ${currentPage.singularName}` : `Create new ${currentPage.singularName}`}
                open={state.dialogOpen}
                loading={state.dialogLoading}
                onSubmit={handleSave}
                onClose={handleDialogVisibility}
                item={(state.editDialog && itemDetails) ? itemDetails.data : {}}
            />}

            {(currentPage.id === "data-type") && <DataDialog
                title={state.editDialog ? `Edit ${currentPage.singularName}` : `Create new ${currentPage.singularName}`}
                open={state.dialogOpen}
                loading={state.dialogLoading}
                type={'data-type'}
                onSubmit={handleSave}
                onClose={handleDialogVisibility}
                item={(state.editDialog && itemDetails) ? itemDetails.data : {}}
            />}

            {(currentPage.id === "data-domain") && <DataDialog
                title={state.editDialog ? `Edit ${currentPage.singularName}` : `Create new ${currentPage.singularName}`}
                open={state.dialogOpen}
                loading={state.dialogLoading}
                type={'data-domain'}
                onSubmit={handleSave}
                onClose={handleDialogVisibility}
                item={(state.editDialog && itemDetails) ? itemDetails.data : {}}
            />}

            {(currentPage.id === "sample-value") && <DataDialog
                title={state.editDialog ? `Edit ${currentPage.singularName}` : `Create new ${currentPage.singularName}`}
                open={state.dialogOpen}
                loading={state.dialogLoading}
                type={'sample-value'}
                onSubmit={handleSave}
                onClose={handleDialogVisibility}
                item={(state.editDialog && itemDetails) ? itemDetails.data : {}}
            />}
        </>

    )

}